var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppcamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 43,
    viewBox: "0 0 48 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6667 5.33334H35.27L31 0.666672H17L12.73 5.33334H5.33335C2.76669 5.33334 0.666687 7.43334 0.666687 10V38C0.666687 40.5667 2.76669 42.6667 5.33335 42.6667H42.6667C45.2334 42.6667 47.3334 40.5667 47.3334 38V10C47.3334 7.43334 45.2334 5.33334 42.6667 5.33334ZM42.6667 38H5.33335V10H14.7834L16.16 8.48334L19.0534 5.33334H28.9467L31.84 8.48334L33.2167 10H42.6667V38ZM24 12.3333C17.56 12.3333 12.3334 17.56 12.3334 24C12.3334 30.44 17.56 35.6667 24 35.6667C30.44 35.6667 35.6667 30.44 35.6667 24C35.6667 17.56 30.44 12.3333 24 12.3333ZM24 31.4667C19.87 31.4667 16.5334 28.13 16.5334 24C16.5334 19.87 19.87 16.5333 24 16.5333C28.13 16.5333 31.4667 19.87 31.4667 24C31.4667 28.13 28.13 31.4667 24 31.4667Z",
    fill: "#68778D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppcamera);
export default __webpack_public_path__ + "static/media/app.camera.cda3b2f7ef59d93ff73bea5f60c6d6c1.svg";
export { ForwardRef as ReactComponent };